module.exports = __webpack_public_path__ + "a228ede1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/cross-black.svg
// module id = 1724
// module chunks = 0 1 15 17 20 22 33